import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import PoratlUnitJobHistory from './portal-unit-job-history.jsx';
export default class PortalUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      showFullPortalAccountDetails: null,
      play: true
    };
  }
  toggleFullPortalAccountDetails() {
    this.setState({
      showFullPortalAccountDetails: !this.state.showFullPortalAccountDetails
    });
  }
  triggerUpload(id) {
    $("#portal-admin-table-row-"+id+" .image-input").trigger('click');
  }
  handleFileConvert(id) {
    let userId = id;
    let uploadInput = document.getElementById(
      'image-input-'+userId
    );
    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener(
        "load",
        function(e) {
        document.getElementById(
          "image-"+userId
        ).src = e.target.result;
        document.getElementById(
          "b64-"+userId
        ).value = e.target.result;
        let newPortalAccountImageData = {
          api_token: window.api_token,
          image: e.target.result,
        };
        $.ajax({
          type: "POST",
          url: '/api/v1/portal/portal-admin/change-account-image/'+userId,
          data: newPortalAccountImageData,
          dataType: "text/json",
          complete: function(response) {
            let infoModal = $('#infomodal');
            if (response.status === 200) {
              $('#infomodallabel').html('Account Image changed successfully');
              $('#infomodal .modal-body').html(
                $.parseHTML(
                  response.responseText.replace(
                    /\"/g,
                    ""
                  )
                )
              );
              infoModal.modal();
              infoModal.on('hidden.bs.modal', function() {
                $('form input').val('').removeClass('active');
                $('form select').val('');
                $('form textarea').val('');
                $('form label').removeClass('active');
              });
            }
            else {
              $('#infomodallabel').html('Error changing Account Image');
              $('#infomodal .modal-body').html(
                $.parseHTML(
                  response.responseText.replace(
                    /\"/g,
                    ""
                  )
                )
              );
              infoModal.modal();
            }
          }
        });
      });
      fileReader.readAsDataURL(
        uploadInput.files[0]
      );
    }
  }
  render() {
    return(
      <div className="portal-admin-table-row-container">
        <Animate
          play={this.state.play}
          start={{opacity: 0}}
          end={{opacity: 1}}
          key={'portal-account-' + this.props.data.id + '-animate'}
        >
          <div className={
              "portal-admin-table-row portal-admin-table-row-summary " +
              (this.state.showFullPortalAccountDetails === true ? ' bold' : '')
            }
            id={
              "portal-admin-table-row-"+
              this.props.data.id
            }
          >
            <div className="cell column-type-unit-id">
                {this.props.data.id}
            </div>
            <div className="cell column-type-company1">
              {this.props.data.company.short_name}
            </div>
            <div className="cell column-type-unit_name">
              {this.props.data.unit_name}
            </div>
            <div className="cell column-type-unit_total_qty_per_yard">
              {this.props.data.unit_total_qty_per_yard}
            </div>
            <div className="cell column-type-yard">
              {this.props.data.yard}
            </div>
            <div className="cell column-type-cleaned_unit_per_yard">
              {this.props.data.cleaned_unit_per_yard_today}
            </div>
            <div className="cell column-type-dirty_unit_per_yard">
              {this.props.data.dirty_unit_per_yard_today}
            </div>
            <div className="cell column-type-account-created">
              {this.props.data.created_at}
            </div>
            <div className="cell column-type-account-last-logged-in">
              {this.props.data.updated_at}
            </div>
            
            <div className="cell column-type-full-details">
              <button
                className="btn btn-dark btn-sm"
                onClick={() => {
                  this.toggleFullPortalAccountDetails()
                }}>
                Latest 10 Job History <i className="fa fa-level-down"></i>
              </button>
            </div>
          </div>
          {(this.state.showFullPortalAccountDetails === true) ?
            <PoratlUnitJobHistory
              key={
                'portal-account-'+
                this.props.data.id+
                '-full-details'
              }
              data={this.props.data}
            />
            :
            null
          }
        </Animate>
      </div>
    )
  }
}
